import isEqual from 'lodash-es/isEqual';
import { useEffect, useRef } from 'react';
import { usePrevious } from './usePrevious';

export const useDeferredChangeEffect = <T>({
  comparisonValue,
  effect,
  waitFor,
}: {
  comparisonValue: T;
  effect: () => void;
  waitFor: boolean;
}) => {
  const shouldFetch = useRef<boolean>();
  const prevValue = usePrevious<T, true>(comparisonValue, true);

  useEffect(() => {
    if (!isEqual(comparisonValue, prevValue)) {
      shouldFetch.current = true;
    }

    if (waitFor && shouldFetch.current) {
      shouldFetch.current = false;
      effect();
    }
  });
};
